import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';

const request = createAppRequest();

export interface UserRecord {
  id?: string;
  uuid?: string;
  userId?: string;
  userUuid?: string;
  memberUuid?: string;
  username?: string;
  nickname?: string;
  name?: string;
  email?: string;
  role?: string;
  is_active?: boolean;
  isEnabled?: boolean;
  status?: string;
  deptIds?: string[];
  orgs?: Array<{
    nodeId?: string;
    orgId?: string;
    name?: string;
    fullLevelName?: string;
  }>;
}

interface UserListResponse {
  success?: boolean;
  data?:
    | UserRecord[]
    | {
        items?: UserRecord[];
        records?: UserRecord[];
        list?: UserRecord[];
        content?: UserRecord[];
        rows?: UserRecord[];
      };
  items?: UserRecord[];
  records?: UserRecord[];
  list?: UserRecord[];
  content?: UserRecord[];
  rows?: UserRecord[];
}

export async function getUsers(options?: ApiRequestOptions): Promise<UserRecord[]> {
  try {
    const response = await request<{ data?: UserRecord[]; total?: number }>('/bff/admin/policy-public/personnel/members', {
      method: 'GET',
      params: {
        page: 1,
        limit: 100,
      },
      ...(options || {}),
    });

    const list = response?.data || [];
    return list.map((item: any) => ({
      id: item.memberUuid || item.id,
      uuid: item.memberUuid || item.uuid,
      memberUuid: item.memberUuid,
      userId: item.userId,
      name: item.displayName || item.name,
      nickname: item.displayName || item.nickname,
      username: item.displayName || item.username,
      isEnabled: item.active !== false && item.status !== 'Disabled',
      is_active: item.active !== false && item.status !== 'Disabled',
    }));
  } catch {
    return [];
  }
}

export async function getCurrentMemberAsUser(options?: ApiRequestOptions): Promise<UserRecord> {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return {
      id: user.memberUuid || user.id,
      memberUuid: user.memberUuid,
      name: user.name || user.nickname || '当前用户',
      isEnabled: true,
      is_active: true,
    };
  } catch {
    return { isEnabled: true, is_active: true };
  }
}
